import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ImportHistoryDialog = ({ open, onOpenChange, onChanged }) => {
  const [batches, setBatches] = useState([]);
  const load = () => api.get("/expense-imports").then((r) => setBatches(r.data));
  useEffect(() => {
    if (open) load();
  }, [open]);

  const remove = async (b) => {
    if (!window.confirm(`Delete all ${b.count} expenses from this import? This cannot be undone.`)) return;
    try {
      const r = await api.post("/expenses/bulk-delete", { ids: b.ids });
      toast.success(`Deleted ${r.data.deleted} expenses`);
      load();
      onChanged?.();
    } catch (e) {
      toast.error("Could not delete this import");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading">Import history</DialogTitle>
        </DialogHeader>
        {batches.length === 0 ? (
          <p className="text-sm text-slate-500" data-testid="imports-empty">No imports found.</p>
        ) : (
          <div className="border border-slate-200 rounded-md divide-y divide-slate-100" data-testid="imports-list">
            {batches.map((b) => (
              <div key={b.id} className="flex items-center gap-4 px-4 py-3 text-sm" data-testid={`import-row-${b.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-slate-900 truncate">{b.file_name}</div>
                  <div className="text-xs text-slate-500">
                    Uploaded {fmtDate((b.created_at || "").slice(0, 10))} · {b.count} expenses
                    {b.date_from && ` · ${fmtDate(b.date_from)} – ${fmtDate(b.date_to)}`}
                  </div>
                </div>
                <Button variant="outline" size="sm" data-testid={`delete-import-${b.id}`} onClick={() => remove(b)} className="rounded-md border-rose-200 text-rose-600 hover:bg-rose-50 hover:text-rose-700">
                  <Trash2 className="h-4 w-4 mr-1" /> Delete import
                </Button>
              </div>
            ))}
          </div>
        )}
        <p className="text-xs text-slate-400">Earlier imports (before this list existed) are grouped by when they were saved — check the date range before deleting.</p>
      </DialogContent>
    </Dialog>
  );
};
